import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Cloud = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M4.5662 9.9044C4.21877 7.38489 5.75523 5.82239 8.09898 5.53593C9.7662 5.33218 10.8594 6.62976 11.1198 7.78028C11.9011 7.26771 13.2477 6.9244 14.349 7.63229C15.573 8.4191 15.638 9.57239 15.2865 10.8224C16.8229 11.0307 17.7865 11.9161 17.7865 13.7391C17.7865 15.562 16.1782 16.4472 14.2448 16.4472H6.58856H5.31249C3.60315 16.4472 2.21356 14.9584 2.21356 13.127C2.21356 11.5726 3.21695 10.2646 4.5662 9.9044Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default Cloud
